const en = {
  contributorsTxt: 'contributors',
  activeHeroes: 'Currently active',
  heroes: 'Heroes',
  socialLinkTxt: 'Social Link',
};

export default en;
